import { ChakraProvider } from '@chakra-ui/react';
import { Theme } from '@radix-ui/themes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { Page } from './components/layouts/Page';
import { AuthContextProvider } from './contexts/AuthContext';
import { HeaderContextProvider } from './contexts/HeaderContext';
import { StepsFormProvider } from './contexts/StepsContext';
import { CampaignProvider } from './pages/corretor/campanhas/context/ContextCampanha';
import { NotificationToast } from './pages/corretor/leads/gestao/components/NotificationToast';
import { EquipesContextProvider } from './pages/corretor/leads/gestao/context/EquipesContext';
import { NotificationProvider } from './pages/corretor/leads/gestao/context/NotificationContext';
import { MovimentacaoFundosProvider } from './pages/corretor/previdencia-individual/movimentacao-fundos/contexts/MovimentacaoFundosContext';
import { AppRoutes } from './routes/AppRoutes';
import { refreshToken, shouldGenerateNewToken } from './services/api-sensedia';
import { theme } from './styles/theme';
import {
  getDadosLogin,
  isDadosLoginTokenValid
} from './utils/dados-login.util';

const queryClient = new QueryClient();
const targeting = () => (window.location.pathname = '/corretor/notificacoes');

const isAtUnauthenticatedPaths = () => {
  const pathname = window.location.pathname;
  return (
    pathname === '/login' ||
    pathname.includes('/confirmacao-email') ||
    pathname.startsWith('/consentimento') ||
    pathname.split('/').find((el) => el === 'c')
  );
};

export const App = () => {
  useEffect(() => {
    const _2segundos = 2e3;

    const refreshTokenInterval = setInterval(() => {
      if (isAtUnauthenticatedPaths()) return;

      const accessToken = localStorage.getItem('tokenPortal');

      const currentRefreshToken = localStorage.getItem('refreshToken');

      if (!accessToken || !currentRefreshToken) return;

      if (!shouldGenerateNewToken()) return;

      refreshToken()
        .then(() => {
          console.log('gerou novo token', new Date());
        })
        .catch((e) => {
          console.log(
            'error refreshing token',
            e,
            localStorage.getItem('tokenPortal')
          );
        });
    }, _2segundos);

    const refreshUserTokenInterval = setInterval(() => {
      if (isAtUnauthenticatedPaths()) return;

      const currentRefreshToken = localStorage.getItem('refreshToken');
      const userDataToken = localStorage.getItem('user-data-token');

      if (!currentRefreshToken || !userDataToken) return;

      if (isDadosLoginTokenValid()) return;

      getDadosLogin()
        .then(() => {
          console.log('gerou novo token dados login', new Date());
        })
        .catch((e) => {
          clearInterval(refreshUserTokenInterval);
          console.log(
            'error refreshing user info token',
            e,
            localStorage.getItem('refreshToken')
          );
        });
    }, _2segundos);

    return () => {
      clearInterval(refreshTokenInterval);
      clearInterval(refreshUserTokenInterval);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <AuthContextProvider>
            <Theme>
              <NotificationProvider>
                <StepsFormProvider>
                  <MovimentacaoFundosProvider>
                    <CampaignProvider>
                      <EquipesContextProvider>
                        <HeaderContextProvider>
                          <NotificationToast open={true} action={targeting}>
                            <Page>
                              <AppRoutes />
                            </Page>
                          </NotificationToast>
                        </HeaderContextProvider>
                      </EquipesContextProvider>
                    </CampaignProvider>
                  </MovimentacaoFundosProvider>
                </StepsFormProvider>
              </NotificationProvider>
            </Theme>
          </AuthContextProvider>
        </BrowserRouter>
      </ChakraProvider>
    </QueryClientProvider>
  );
};
